var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.38342,
    y: 1,
    width: 42,
    height: 38,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.38342,
    y: 1,
    width: 42,
    height: 38,
    rx: 4,
    stroke: "#DBE2E9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8834 16.6828C14.8834 14.2164 17.1333 11.7192 19.847 11.7192C21.6832 11.7192 23.2876 12.7158 24.1471 14.2016C24.2961 14.4591 24.571 14.6176 24.8685 14.6176H25.644C26.6573 14.6176 27.6395 14.9758 28.3563 15.5414C29.074 16.1077 29.4667 16.8278 29.4667 17.5525C29.4667 18.4068 29.4546 19.0468 29.138 19.6798C28.9322 20.0915 29.0991 20.592 29.5107 20.7978C29.9224 21.0037 30.4229 20.8368 30.6288 20.4252C31.134 19.4147 31.1337 18.4107 31.1334 17.6073L31.1334 17.5525C31.1334 16.1939 30.3987 15.0299 29.3887 14.2329C28.3777 13.4353 27.0319 12.951 25.644 12.951H25.3281C24.1355 11.2027 22.126 10.0525 19.847 10.0525C16.1576 10.0525 13.2167 13.3522 13.2167 16.6828L13.2167 16.7115C13.2167 17.5752 13.2166 18.9373 13.6762 20.316C13.8217 20.7526 14.2936 20.9886 14.7303 20.8431C15.1669 20.6975 15.4028 20.2256 15.2573 19.789C14.8887 18.6831 14.8834 17.5601 14.8834 16.6828ZM22.1718 30C22.6412 30 23.0218 29.6194 23.0218 29.15V21.0199L25.0328 22.9794C25.369 23.307 25.9072 23.3 26.2348 22.9638C26.5624 22.6275 26.5554 22.0894 26.2192 21.7618L22.9047 18.5322C22.4966 18.1346 21.846 18.135 21.4384 18.5329L18.1304 21.7624C17.7945 22.0903 17.7881 22.6284 18.116 22.9644C18.4439 23.3003 18.9821 23.3067 19.318 22.9788L21.3218 21.0226V29.15C21.3218 29.6194 21.7023 30 22.1718 30Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIc);
export default __webpack_public_path__ + "static/media/upload_ic.3b152d225f6aa75c059e0b2fdeb02137.svg";
export { ForwardRef as ReactComponent };